import {
  LexiconTeaser,
  TruncatedArticleList,
} from "components/page-components/Teaser-Cards"

import React from "react"

export const RecommendedLexiconPosts = ({ related_lexicon_posts }) => {
  return (
    <div data-nosnippet className="mt-6 ">
      <p className="title is-4 mb-5 ml-3">Vergabe-Wissen in kleinen Häppchen</p>
      <div className="columns is-centered ">
        {related_lexicon_posts.slice(0, 3).map((post, index) => (
          <div key={`lexicon-teaser-${index}`} className="column is-4">
            <LexiconTeaser
              {...{
                char: post.frontmatter.slugline?.charAt(0),
                index,
                question_bottom: post.frontmatter.title,
                slug: post.frontmatter.slugline,
              }}
            />
          </div>
        ))}
      </div>
      {related_lexicon_posts.length > 3 ? (
        <div className="ml-3">
          <TruncatedArticleList
            {...{
              listedArticles: related_lexicon_posts.slice(3),
            }}
          />
        </div>
      ) : null}
    </div>
  )
}
